export const UNSELECTED = 'unselected'
export const SELECTED = 'selected'

export const ALL_SIGNER = [UNSELECTED, SELECTED] as const

export type signer = (typeof ALL_SIGNER)[number]
